<template>
    <div>
    </div>
</template>

<script>
import { suppliosApi } from '@/js/api-service';

export default {
    name: 'SwitchAccountsConfirm',
    components: {},
    props: {
        
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
        }
    },
    methods: {
        logout: function(redirectToUrl) {
            // show a confirm modal, then if user clicks "logout" call performLogout to actually do it
            // pass in the URL to redirect to after logout -- we ignore the normal one passed back from logout API call because that is for the tenant we are currently on, not the one we are going to
            this.$bvModal.msgBoxConfirm('Are you sure you want to switch accounts?  This will log you out of your current account.', {
                title: 'Switch to this account?',
                size: 'sm',
                buttonSize: 'md',
                okVariant: 'primary',
                okTitle: 'Yes, switch to this account',
                cancelTitle: 'No, Cancel',
                bodyClass: 'text-center',
                headerClass: '',
                footerClass: 'p-2 border-top-0 justify-content-center',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value) {
                    this.performLogout(redirectToUrl);
                }
            })
        },
        performLogout: function(redirectToUrl) {
            suppliosApi.auth.logout()
            .then(() => {
                console.log('you should be redirected to', redirectToUrl)
                window.location.replace(redirectToUrl);
            })
            .catch(err => {
                this.handleError(err, 'Error while trying to logout');
            })
        },
        handleError: function(error, message) {
            this.errorMsg = message;
            this.error = true;
            this.$toast.error(message, {timeout: false});
        },
    }
}
</script>
<style>
</style>
